export default __webpack_public_path__ + "static/media/webdevelopment.48ae91af.png";